import { Switch } from 'react-router-dom'
import {
  CIMSModule,
  CIMSPage,
  CIMSPageItem,
  pathify,
  Permission,
} from '@cims-online/shared'
import Snapshots from './components/Snapshots'
import UserSync from './components/UserSync'
import { ProtectedRoute } from '../../../../../components/ProtectedRoute'
import Developers from './components/Developers'
import Redis from './components/Redis'
import AssociateProject from './components/AssociateProject'
import DevelopersModuleProvider from './DevelopersModuleContext'
import Workflows from './components/Workflows'

const Developer: React.FC = () => {
  const path = ({ pathname }: CIMSPageItem) =>
    pathify(CIMSModule.Developer.pathname, pathname)
  return (
    <Switch>
      <DevelopersModuleProvider>
        <ProtectedRoute path={path(CIMSPage.DeveloperSnapshots)} developer>
          <Snapshots />
        </ProtectedRoute>
        <ProtectedRoute
          path={path(CIMSPage.UserSync)}
          permissions={Permission.SyncUsers}
        >
          <UserSync />
        </ProtectedRoute>
        <ProtectedRoute path={path(CIMSPage.Developers)} developer>
          <Developers />
        </ProtectedRoute>
        <ProtectedRoute
          path={path(CIMSPage.AssociateProject)}
          permissions={Permission.AssociateProjectWithCIMS}
        >
          <AssociateProject />
        </ProtectedRoute>
        <ProtectedRoute
          path={path(CIMSPage.Redis)}
          permissions={Permission.RefreshRedisCache}
        >
          <Redis />
        </ProtectedRoute>
        <ProtectedRoute path={path(CIMSPage.Workflows)} developer>
          <Workflows />
        </ProtectedRoute>
      </DevelopersModuleProvider>
    </Switch>
  )
}

export default Developer
